String.prototype.toStringArray = function() {
  return JSON.parse(this).map(String);
};
